<template>
  <div class="main">
    <div class="header">
      <span class="headerTitle">用户登陆</span>
    </div>
    <a-form id="formLogin" class="user-layout-login" ref="formLogin" :form="form" @submit="handleSubmit"
      :hideRequiredMark="true" :label-col="{ span: 16 }" :wrapper-col="{ span: 24 }">
      <a-form-item label>
        <a-input size="large" type="text" :placeholder="$t('user.login.username.placeholder')" v-decorator="[
          'username',
          {
            rules: [
              { required: true, message: $t('user.userName.required') },
              { validator: handleUsernameOrEmail }
            ],
            validateTrigger: 'change'
          }
        ]">
          <a-icon slot="prefix" type="user" :style="{ color: '#1D76CA' }" />
        </a-input>
      </a-form-item>

      <a-form-item label>
        <a-input type="password" size="large" :placeholder="$t('user.login.password.placeholder')" v-decorator="[
          'password',
          { rules: [{ required: true, message: $t('user.password.required') }], validateTrigger: 'blur' }
        ]">
          <a-icon slot="prefix" type="lock" :style="{ color: '#1D76CA' }" />
        </a-input>
      </a-form-item>

      <a-row :gutter="8">
        <a-col :span="16">
          <a-form-item label>
            <a-input size="large" :placeholder="$t('user.login.code.placeholder')" v-decorator="[
              'code',
              { rules: [{ required: true, message: $t('user.login.code.required') }], validateTrigger: 'blur' }
            ]">
              <a-icon slot="prefix" type="safety-certificate" :style="{ color: '#1D76CA' }" />
            </a-input>
          </a-form-item>
        </a-col>
        <a-col :span="8" style="margin-top:5px">
          <img :src="baseUrl + 'auth/auth/captcha?uuid=' + uuid" @click="refreshCaptcha()" style="width:100%" />
        </a-col>
      </a-row>

      <div style="text-align: right;color: #1890ff">
        <a @click="forgetPassword"> 忘记密码
        </a>
      </div>

      <a-form-item style="margin-top:20px">
        <a-button size="large" type="primary" htmlType="submit" class="login-button" :loading="state.loginBtn"
          :disabled="state.loginBtn">{{ $t('user.login.login') }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import TwoStepCaptcha from '@/components/tools/TwoStepCaptcha'
import { mapActions } from 'vuex'
import { timeFix, getUUID } from '@/utils/util'
import { getSmsCaptcha } from '@/api/login'
import { toEncryption, getKeypair, toDeciphering } from '@/utils/sm2'
import moment from 'moment'
import notification from 'ant-design-vue/es/notification'

export default {
  components: {
    TwoStepCaptcha
  },
  data () {
    return {
      customActiveKey: 'tab1',
      loginBtn: false,
      uuid: getUUID(),
      // login type: 0 email, 1 username, 2 telephone
      loginType: 0,
      isLoginError: false,
      requiredTwoStepCaptcha: false,
      stepCaptchaVisible: false,
      form: this.$form.createForm(this),
      baseUrl: process.env.VUE_APP_API_BASE_URL,
      state: {
        time: 60,
        loginBtn: false,
        // login type: 0 email, 1 username, 2 telephone
        loginType: 0,
        smsSendBtn: false
      }
    }
  },
  methods: {
    ...mapActions(['Login', 'Logout']),
    forgetPassword () {
      this.$message.warn('普通用户请联系租户管理员重置密码')
    },
    // 刷新验证码
    refreshCaptcha () {
      this.uuid = getUUID()
    },
    // handler
    handleUsernameOrEmail (rule, value, callback) {
      const { state } = this
      const regex = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
      if (regex.test(value)) {
        state.loginType = 0
      } else {
        state.loginType = 1
      }
      callback()
    },
    handleTabClick (key) {
      this.customActiveKey = key
    },
    // 写入数据
    addLogin (us, list) {
      console.log('写入数据===')
      const time = moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss.SSS')
      const obj = { username: us, date: time, num: 0, isLogin: true }
      list.push(obj)
      localStorage.setItem('Login', JSON.stringify(list))
    },
    // 更新数据
    upLogin (us, isjs) {
      console.log('更新数据===')
      const list = JSON.parse(localStorage.getItem('Login'))
      const arr = []
      let arrIndex = 0
      list.forEach((ele, index) => {
        if (ele.username === us) {
          arr.push(ele)
          arrIndex = index
        }
      })
      if (arr.length > 0) {
        list[arrIndex].num = arr[0].num + 1
        list[arrIndex].date = moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss.SSS')
        console.log('更新数据===计数器加1===', list[arrIndex].num)
        if (list[arrIndex].num === 3) {
          console.log('更新数据===累计超过3次锁死账号===', list[arrIndex].username)
          list[arrIndex].isLogin = false
        }
        localStorage.setItem('Login', JSON.stringify(list))
      } else {
        console.log('存在Login===新账号登录===')
        this.addLogin(us, list)
      }
    },
    // 判断账号是否锁死
    isUserLockedUp (us) {
      // const { state } = this
      console.log('判断账号是否锁死===')
      const loginobj = localStorage.getItem('Login')
      let isOk = true
      if (loginobj) {
        const list = JSON.parse(loginobj)
        list.forEach(element => {
          if (element.username === us) {
            const dtime = this.differenceTime(element.date)
            console.log('距离上次登录点击时间===', dtime)
            // 计算时间差
            if (dtime > 5) {
              element.isLogin = true
              element.num = 0
            }
            isOk = element.isLogin
          }
        })
        localStorage.setItem('Login', JSON.stringify(list))
      } else {
        console.log('第一次登录===')
        this.addLogin(us, [])
        isOk = true
      }
      return isOk
    },
    handleSubmit (e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state,
        uuid,
        customActiveKey,
        Login
      } = this
      state.loginBtn = true
      const validateFieldsKey = customActiveKey === 'tab1' ? ['username', 'password', 'code'] : ['mobile', 'captcha']
      validateFields(validateFieldsKey, { force: true }, (err, values) => {
        if (!err) {
          if (this.isUserLockedUp(values.username)) {
            const loginParams = { ...values, uuid }
            delete loginParams.username
            loginParams[!state.loginType ? 'email' : 'username'] = values.username
            // console.log('===原始密码===', loginParams.password)
            const obj = getKeypair(loginParams.password)
            // console.log('===公钥加密keypair===', obj)
            const intPwd = toEncryption(loginParams.password) 
            loginParams.newPassword = intPwd
            delete loginParams.password
            Login(loginParams)
              .then(res => {
                console.log('===then===')
                this.loginSuccess(res)
              })
              .catch(err => {
                console.log('===err===')
                this.requestFailed(err, loginParams.username)
              })
              .finally(() => {
                state.loginBtn = false
              })
          } else {
            notification['error']({
              message: '系统提示:',
              description: '该账号因连续登录失败后已锁死，请联系系统管理员！或五分钟后再进行登录！'
            })
            state.loginBtn = false
          }
        } else {
          setTimeout(() => {
            state.loginBtn = false
          }, 600)
        }
      })
    },
    getCaptcha (e) {
      e.preventDefault()
      const {
        form: { validateFields },
        state
      } = this
      validateFields(['mobile'], { force: true }, (err, values) => {
        if (!err) {
          state.smsSendBtn = true
          const interval = window.setInterval(() => {
            if (state.time-- <= 0) {
              state.time = 60
              state.smsSendBtn = false
              window.clearInterval(interval)
            }
          }, 1000)
          const hide = this.$message.loading('验证码发送中..', 0)
          getSmsCaptcha({ mobile: values.mobile })
            .then(res => {
              setTimeout(hide, 2500)
              this.$notification['success']({
                message: '提示',
                description: '验证码获取成功，您的验证码为：' + res.result.captcha,
                duration: 8
              })
            })
            .catch(err => {
              setTimeout(hide, 1)
              clearInterval(interval)
              state.time = 60
              state.smsSendBtn = false
              this.requestFailed(err)
            })
        }
      })
    },
    stepCaptchaSuccess () {
      this.loginSuccess()
    },
    stepCaptchaCancel () {
      this.Logout().then(() => {
        this.loginBtn = false
        this.stepCaptchaVisible = false
      })
    },
    loginSuccess (res) {
      const redirect = this.$route.query.redirect || '/'
      // 登录成功后，手动拉取用户信息和动态路由，确保addRoutes已挂载
      this.$store.dispatch('GetInfo').then(res => {
        const roles = res.data && res.data.role
        this.$store.dispatch('GenerateRoutes', { roles }).then(() => {
          this.$router.addRoutes(this.$store.getters.addRouters)
          this.$router.replace({ path: redirect })
          setTimeout(() => {
            this.$notification.success({
              message: '欢迎',
              description: `${timeFix()}，欢迎回来`
            })
          }, 1000)
          this.isLoginError = false
        })
      })
    },
    differenceTime (start) {
      const xz = moment(moment(new Date().getTime()).format('YYYY-MM-DD HH:mm:ss.SSS'), 'YYYY-MM-DD HH:mm:ss')
      const seconds = xz.diff(start, 'seconds')
      return Number(seconds / 60)
    },
    requestFailed (err, us) {
      const { data } = err
      const errorMessage = (data?.message || data?.error_description || '').toLowerCase()
      
      // 检测验证码相关错误（包括过期、错误、无效等情况）
      if (errorMessage && (errorMessage.includes('图形验证码过期') || errorMessage.includes('captcha'))) {
        // 验证码过期或错误，自动刷新验证码
        this.refreshCaptcha()
        // 清空验证码输入框
        this.form.setFieldsValue({ code: '' })
      } else if (data?.message === '用户名或密码错误！！！') {
        this.upLogin(us)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.footer {
  // position: absolute;
  width: 100%;
  bottom: 0;
  padding: 0 16px;
  margin: 48px 0 24px;
  text-align: center;

  .links {
    margin-bottom: 8px;
    font-size: 14px;

    a {
      color: rgba(0, 0, 0, 0.45);
      transition: all 0.3s;

      &:not(:last-child) {
        margin-right: 40px;
      }
    }
  }

  .copyright {
    color: rgba(0, 0, 0, 0.45);
    font-size: 14px;
  }
}

.main {
  min-height: 38.2%;
  // padding-top: 15.3%;

  right: 11.3%;
  top: 32%;
  position: absolute;
  display: flex;
  flex-direction: column;
  padding: 20px 40px;
  // padding-top:0;
  // background: red;
  background: rgba(3, 24, 66, 0.7);
  border: 2px solid #07407a;
  border-radius: 10px;
}

.header {
  display: block;
  margin-bottom: 24px;
  text-align: center;

  .headerTitle {
    font-family: MicrosoftYaHeiSemibold;
    font-size: 20px;
    color: #0adcff;
    font-weight: 600;
  }
}

.user-layout-login {
  label {
    font-size: 14px;
  }

  .getCaptcha {
    display: block;
    width: 100%;
    height: 40px;
  }

  .forge-password {
    font-size: 14px;
  }

  button.login-button {
    border-radius: 2px;
    padding: 0 15px;
    font-size: 16px;
    height: 40px;
    width: 100%;
    background: #136dc8;
  }

  .user-login-other {
    text-align: left;
    margin-top: 24px;
    line-height: 22px;

    .item-icon {
      font-size: 24px;
      color: rgba(0, 0, 0, 0.2);
      margin-left: 16px;
      vertical-align: middle;
      cursor: pointer;
      transition: color 0.3s;

      &:hover {
        color: #1890ff;
      }
    }

    .register {
      float: right;
    }
  }
}

/deep/.ant-input {
  background: rgba(4, 45, 97, 0.5);
  border: 1px solid #136cc2;
  border-radius: 2px;
  font-size: 14px;
  color: #fff;
}

/deep/.has-error .ant-input-affix-wrapper .ant-input,
.has-error .ant-input-affix-wrapper .ant-input:hover {
  background: rgba(4, 45, 97, 0.5);
  border: 1px solid #136cc2;
  border-radius: 2px;
  font-size: 14px;
  color: #fff;
}

/deep/.ant-input:focus {
  background: rgba(4, 45, 97, 0.5);
  border: 1px solid #136cc2;
  border-radius: 2px;
  color: #fff;
  font-size: 14px;
}

/deep/input::-webkit-input-placeholder,
.inputHead {
  font-family: MicrosoftYaHeiSemibold;
  font-size: 14px;
  color: #87b3ff;
  //输入框颜色
}
</style>
